<template>
  <div class="myaccount">
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <CommonHead></CommonHead>
    <b-modal
      id="order-hold-cancel-success"
      ref="modal1"
      title="Your order has been successfully canceled"
      title-tag="h3"
      ok-only
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOkClose"
      no-stacking
      modal-class="common_pop cancel_success_pop"
    ></b-modal>
    <b-modal
      id="order-hold-cancel"
      ref="modal"
      title="Are you sure you want to cancel the order?"
      title-tag="h3"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
      no-stacking
      modal-class="common_pop cancel_order_pop"
    >
      <b-row>
        <b-col cols="7">
          <b-button @click="handleOk" type="button" block variant="dark">Yes</b-button>
        </b-col>
        <b-col cols="5">
          <b-button @click="hideModal" block variant="outline-primary" squared>No</b-button>
        </b-col>
      </b-row>
    </b-modal>
    <div class="accountdetails">
      <sidebar></sidebar>
      <div class="orderspage">
        <div class="singleorder">
          <b-link @click="$router.go(-1)" class="backtoorder">
            <b-img class="backarrow" src="/shop/images/arrow.svg" alt="Arrow image"></b-img>Back to Orders
          </b-link>
          <div class="orderinfo">
            <div class="detailedinfo">
              <h3>Order Information</h3>
              <div class="samediv">
                <span>Order #</span>
                <p>{{orderdetails.salesid}}</p>
              </div>
              <div class="samediv">
                <span>Date</span>
                <p>{{orderdetails.DateCreated}}</p>
              </div>
              <div class="samediv">
                <span>Hold Type</span>
                <p>{{orderdetails.RMCSALESHOLDFIVEDAYS=='1'?'10 Day Hold':'Cutting For Approval'}}</p>
              </div>
              <div class="samediv">
                <p>Note: Order will be auto canceled after 10 days since placing order.</p>
              </div>
              <div class="orderimg" v-for="(item, ik) in orderdetails.items" :key="ik">
                <div class="imgcont">
					<router-link :to="'/product/'+item.rmcchilditem+'/'+item.INVENTCOLORID">
						<b-img :src="item.SMALL_IMAGE" alt="order image"></b-img>
					</router-link>
                </div>
                <div class="detailcont">
                  <h3>{{item.ItemName}}</h3>
                  <div class="samediv">
                    <span>ID :</span>
                    <p>{{item.rmcchilditem}}-{{item.INVENTCOLORID}}</p>
                  </div>
                  <div class="samediv">
                    <span>Price :</span>
                    <p>$ {{item.SALESPRICE}}</p>
                  </div>
                  <div class="samediv">
                    <span>Qty :</span>
                    <p>{{item.salesqty}}</p>
                  </div>
                  <div class="samediv">
                    <span>Subtotal:</span>
                    <p>$ {{item.SUBTOTAL}}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="downloadpdf addressedit">
              <div class="boxgrid" v-if="orderdetails.RMCSALESHOLDFIVEDAYS=='1'">
                <h3>Shipping Address</h3>
                <b-link v-if="hideEdit == true" href="javascript:;" @click="RemoveReadonly" class="downpdf edit">
                  <b-img class="editad" src="/shop/images/edit.svg" alt="Edit image"></b-img>Edit
                </b-link>
                <b-link v-if="hideEdit == true" href="javascript:;" @click="SaveForm" class="downpdf save">
                  <b-img class="editad" src="/shop/images/edit.svg" alt="Edit image"></b-img>Save
                </b-link>
                <b-form class="commonform OrderHoldForm" @submit="onSubmit">
                  <b-row>
                    <b-col>
                      <md-field :state="!form.errors.has('addline1')" :class="form.errors.get('addline1')?'haserror':''"
                          :invalid-feedback="form.errors.get('addline1')">
                        <label>Address Line 1</label>
                        <md-input :readonly="isReadonly" :state="!form.errors.has('addline1')"
                              @input="form.errors.clear('addline1')" v-model="form.addline1" type="text"></md-input>
                      </md-field>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <md-field :state="!form.errors.has('city')" :class="form.errors.get('city')?'haserror':''"
                          :invalid-feedback="form.errors.get('city')">
                        <label>City</label>
                        <md-input :readonly="isReadonly" :state="!form.errors.has('city')"
                              @input="form.errors.clear('city')" v-model="form.city" type="text"></md-input>
                      </md-field>
                    </b-col>
                    <b-col>
                      <md-field :state="!form.errors.has('state')" :class="form.errors.get('state')?'haserror':''"
                          :invalid-feedback="form.errors.get('state')">
                        <label>State</label>
                        <md-input :readonly="isReadonly" :state="!form.errors.has('state')"
                              @input="form.errors.clear('state')" v-model="form.state" type="text"></md-input>
                      </md-field>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <md-field :state="!form.errors.has('country')" :class="form.errors.get('country')?'haserror':''"
                          :invalid-feedback="form.errors.get('country')">
                        <label>Country</label>
                        <md-input :readonly="isReadonly" :state="!form.errors.has('country')"
                              @input="form.errors.clear('country')" v-model="form.country" type="text"></md-input>
                      </md-field>
                    </b-col>
                    <b-col>
                      <md-field :state="!form.errors.has('zip')" :class="form.errors.get('zip')?'haserror':''"
                          :invalid-feedback="form.errors.get('zip')">
                        <label>Zip Code</label>
                        <md-input :readonly="isReadonly" :state="!form.errors.has('zip')"
                              @input="form.errors.clear('zip')" v-model="form.zip" type="number"></md-input>
                      </md-field>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <p class="note">
                        Note: Please contact customer service at 800-325-8025
                        for editing product quantity or any other modification
                        related to this order.
                      </p>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-button type="submit" block variant="dark">Submit Approval</b-button>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-button
                        v-b-modal.order-hold-cancel
                        block
                        variant="outline-primary"
                      >Cancel Order</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </div>
			  <div class="boxgrid" v-else>
				<b-row>
                    <b-col>
                      <p class="note">
                        Note: For any order modifications and approval/cancellation, 
						please contact customer care service at  800.325.8025.
                      </p>
                    </b-col>
                </b-row>
			  </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CommonFoot></CommonFoot>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Sidebar from "@/components/Sidebar";
import CommonHead from "@/components/CommonHead";
import CommonFoot from "@/components/CommonFoot";
import ResourceMixin from "../../mixins/resources";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    Sidebar,
    CommonHead,
    CommonFoot,
    Loading
  },
  mixins: [ResourceMixin],
  computed: {
	 isReadonly() {
	  return true;
	 }
	},
  mounted() {
      this.isLoading = true;
      this.$store.dispatch("loadOrderInfo",this.$route.params.salesid).then(orderdetails => {
          this.orderdetails = orderdetails.data;
          this.form.addline1= orderdetails.data.Del_street;
          this.form.city= orderdetails.data.Del_City;
          this.form.state= orderdetails.data.Del_State;
          this.form.country= orderdetails.data.Del_Country;
          this.form.zip= orderdetails.data.Del_zip;
          this.isLoading = false;
      });
  },
  beforeMount() {
    this.initForm();
  },
 
  data() {
    return {
      form: {
        addline1: null,
        addline2: null,
        city: null,
        state: null,
        country: null,
        zip: null,
      },
      hideEdit:false,
      orderdetails:[],
      isLoading: false,
      breadcrumb: [
        {
          text: "My Account",
          active: true
        }
      ]
    };
  },
  methods: {
    initForm() {
      this.form = new Form({
        addline1: null,
        addline2: null,
        city: null,
        state: null,
        country: null,
        zip: null
      });
    },
	RemoveReadonly(){
		$(".OrderHoldForm input").removeAttr("readOnly");
		$(".downpdf.edit").hide();
		$(".downpdf.save").show();
		//$(".OrderHoldForm input:text").first().focus();
	},
	SaveForm(){
    this.$store
      .dispatch("updateSalesOrderAddress", {
        form: this.form,
        salesid:this.$route.params.salesid
      })
      .then(() => {
        this.$notify({
          text: "Shipping address has been updated.",
          type: "success"
        });
        $(".OrderHoldForm input").attr("readonly",true);
        $(".downpdf.edit").show();
        $(".downpdf.save").hide();
      })
	},
    onSubmit(evt) {
      evt.preventDefault();
      this.$store
      .dispatch("ApproveHoldOrder", {
        form: this.form,
        salesid:this.$route.params.salesid
      })
      .then(() => {
        this.$router.push("/shop/orders/onhold-orders");
        this.$notify({
          text: "Thank you for approving your order, customer service will begin to process your order as soon as possible.",
          type: "success"
        });
      })
      .catch(error => {
        if (this.form.hasErrors()) {
          this.$notify({
            text:
              "There is a validation error. Please correct the fields outlined in red and try again.",
            type: "error"
          });
        } else {
          this.$notify({
            text: "Something went wrong!",
            type: "error"
          });
        }
      });
    },
    hideModal() {
      this.$refs["modal"].hide();
    },
	
    resetModal(){},
    handleOk(evt){ 
	    evt.preventDefault();
      this.isLoading = true;
      this.$store
      .dispatch("CancelHoldOrder", {
        salesid:this.$route.params.salesid
      })
      .then(() => {
        this.$refs["modal"].hide();
        this.$refs["modal1"].show();
        this.$notify({
          text: "Thank you, your order has been cancelled.",
          type: "success"
        });
        this.$router.push("/shop/orders/onhold-orders");
      })
      .catch(error => {
        
          this.$notify({
            text: "Something went wrong!",
            type: "error"
          });
        
      });
      this.isLoading = false;
    },
    handleOkClose(){}
  }
};
</script>
<style>
.downpdf.save{
display:none;
}
.accountdetails .orderspage .singleorder .orderinfo .addressedit {
  width: 71.5%;
}
.accountdetails
  .orderspage
  .singleorder
  .orderinfo
  .addressedit
  form.commonform {
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 100%;
}
.accountdetails .orderspage .singleorder .orderinfo .addressedit .boxgrid {
  padding: 20px 30px;
}
#app
  .accountdetails
  .orderspage
  .singleorder
  .orderinfo
  .addressedit
  .boxgrid
  .md-field {
  margin-bottom: 5px;
}

.addressedit h3 {
  float: left;
  font-weight: 600;
}
.addressedit .downpdf {
  font-weight: 600;
  font-size: 14px;
  color: #303030;
}
.addressedit .downpdf:hover {
  border-bottom: 1px solid #303030;
}
.addressedit img.editad {
  height: 12px;
  width: 12px;
  float: left;
  margin-top: 3px;
  margin-right: 6px;
}
.accountdetails
  .orderspage
  .singleorder
  .orderinfo
  .addressedit
  .boxgrid
  p.note {
  font-size: 12px;
  line-height: 24px;
  color: #777777;
  font-weight: normal;
  margin: 25px 0;
}
.accountdetails
  .orderspage
  .singleorder
  .orderinfo
  .addressedit
  .boxgrid
  .btn.btn-dark {
  margin: 0 0 20px 0;
}
.cancel_order_pop .modal-body {
  padding: 0;
}
.cancel_success_pop h3 {
  margin-top: 25px;
}
.cancel_success_pop .modal-body {
  display: none;
}
@media only screen and (max-width:1024px) and (min-width:768px){
  .accountdetails .orderspage .singleorder .orderinfo .addressedit {
    width: 100%;
  }
  .accountdetails .orderspage .singleorder .orderinfo .addressedit .boxgrid{
    padding: 20px;
	max-width:100%;
  }
}
@media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 2){
	.accountdetails .orderspage .singleorder .orderinfo .addressedit {
		width: 73%;
	}
}
@media only screen and (max-width:767px){
  .accountdetails .orderspage .singleorder .orderinfo .addressedit {
    width: 100%;
  }
  .accountdetails .orderspage .singleorder .orderinfo .addressedit .boxgrid{
    padding: 20px;
  }
}
</style>